/**
 * Focus file format: array of scenes with start_time and focus_box (TBLR).
 * Used for AI-based auto-reframing (subject tracking).
 */
export interface FocusBoxTBLR {
  Left: string;
  Top: string;
  Right: string;
  Bottom: string;
}

export interface FocusScene {
  scene_id: number;
  start_time: string;
  focus_box: FocusBoxTBLR;
}

/**
 * Parses start_time string "HH:MM:SS.mmm" to milliseconds.
 */
export function parseFocusStartTimeMs(startTime: string): number {
  const parts = startTime.trim().split(/[.:]/);
  const h = parts.length >= 1 ? parseFloat(parts[0]) || 0 : 0;
  const m = parts.length >= 2 ? parseFloat(parts[1]) || 0 : 0;
  const s = parts.length >= 3 ? parseFloat(parts[2]) || 0 : 0;
  const ms = parts.length >= 4 ? parseFloat(parts[3]) || 0 : 0;
  return (h * 3600 + m * 60 + s) * 1000 + ms;
}
